<template>
  <div>
    <div class="IHD-table-head d-flex align-items-center mt-3">
      <div
        :style="roles.includes('PUT_JOB') ? 'width: 30%' : 'width: 35%'"
        style="padding-left: 18px"
        class="d-flex align-items-center"
      >
        Job name
        <!-- <img  class="pointer pl-2" src="@/assets/img/accessconnew/ascSort.svg" alt="" />
                <img  class="pointer pl-2" src="@/assets/img/accessconnew/descSort.svg" alt="" /> -->
        <!-- <img
          class="pointer pl-2"
          src="@/assets/img/accessconnew/nosort.svg"
          alt=""
        /> -->
      </div>
      <div
        :style="roles.includes('PUT_JOB') ? 'width: 11%' : 'width: 16%'"
        class="d-flex align-items-center"
      >
        Positions
        <!-- <img  class="pointer pl-2" src="@/assets/img/accessconnew/ascSort.svg" alt="" />
                <img  class="pointer pl-2" src="@/assets/img/accessconnew/descSort.svg" alt="" /> -->
        <!-- <img
          class="pointer pl-2"
          src="@/assets/img/accessconnew/nosort.svg"
          alt=""
        /> -->
      </div>
      <div
        :style="roles.includes('PUT_JOB') ? 'width: 12%' : 'width: 17%'"
        class="d-flex align-items-center"
      >
        Candidates
        <!-- <img  class="pointer pl-2" src="@/assets/img/accessconnew/ascSort.svg" alt="" />
                <img  class="pointer pl-2" src="@/assets/img/accessconnew/descSort.svg" alt="" /> -->
        <!-- <img
          class="pointer pl-2"
          src="@/assets/img/accessconnew/nosort.svg"
          alt=""
        /> -->
      </div>
      <div
        :style="roles.includes('PUT_JOB') ? 'width: 12%' : 'width: 17%'"
        class="d-flex align-items-center"
      >
        Selected
        <!-- <img  class="pointer pl-2" src="@/assets/img/accessconnew/ascSort.svg" alt="" />
                <img  class="pointer pl-2" src="@/assets/img/accessconnew/descSort.svg" alt="" /> -->
        <!-- <img
          class="pointer pl-2"
          src="@/assets/img/accessconnew/nosort.svg"
          alt=""
        /> -->
      </div>
      <div v-if="roles.includes('PUT_JOB')" style="width: 22%">Status</div>
      <div
        :style="roles.includes('PUT_JOB') ? 'width: 13%' : 'width: 15%'"
        class="text-center"
      >
        Actions
      </div>
    </div>
    <div
      class="IHD-table-body overflow-auto"
      @scroll="$emit('onScroll', $event)"
    >
      <div
        class="IHD-table-rows position-relative mt-2 h-fitcontent"
        v-for="(job, index) in jobList"
        :key="index"
        :class="{
          'mt-3': job.automatic,
          pointer:
            (roles.includes('GET_JOBDASHBOARD') ||
              roles.includes('GET_JOB_STATISTICS')) &&
            job.status === '3' &&
            job.active &&
            !job.closed,
          'IHD-inactive-rows': !job.active || job.closed,
        }"
        @click="
          job.status === '3' && job.active && !job.closed && goToJobDetails(job)
        "
      >
        <div
          v-if="job.automatic"
          class="blue-gradientcard"
          style="top: -12px !important"
        >
          Automated Job
        </div>
        <div class="d-flex align-items-center h-100">
          <div
            class="IHD-table-blueline"
            :class="{
              'IHD-inactive-redline': !job.active || job.closed,
            }"
          ></div>
          <div
            :style="roles.includes('PUT_JOB') ? 'width: 30%' : 'width: 35%'"
            class="pl-3 text-truncate pr-2"
          >
            {{ job.title }}
          </div>
          <div :style="roles.includes('PUT_JOB') ? 'width: 11%' : 'width: 16%'">
            {{ job.positions >= 10 ? job.positions : `0${job.positions}` }}
          </div>
          <div :style="roles.includes('PUT_JOB') ? 'width: 12%' : 'width: 17%'">
            {{ job.candidates >= 10 ? job.candidates : `0${job.candidates}` }}
          </div>
          <div
            :style="roles.includes('PUT_JOB') ? 'width: 12%' : 'width: 17%'"
            class="d-flex align-items-center"
          >
            {{ job.selected >= 10 ? job.selected : `0${job.selected}` }}
          </div>
          <template v-if="roles.includes('PUT_JOB')">
            <template v-if="job.active && !job.closed">
              <div style="width: 22%">
                <template>
                  <span
                    v-if="
                      job.status_display === 'Saved to draft' ||
                      job.status_display === 'IP setup pending'
                    "
                  >
                    <img
                      class="IHD-list-status-imgs"
                      src="../../assets/img/newworkbench/internalhiring/draft.svg"
                      alt=""
                    />
                  </span>

                  <span
                    v-if="
                      job.status_display === 'Sent for approval' && !job.closed
                    "
                    ><img
                      class="IHD-list-status-imgs"
                      src="../../assets/img/newworkbench/internalhiring/noti-sentfrapproval.svg"
                      alt=""
                  /></span>
                  <span
                    v-if="
                      (job.status_display === 'Accepted' ||
                        job.status_display === 'Approved' ||
                        job.status_display === 'Published') &&
                      !job.closed
                    "
                  >
                    <img
                      class="IHD-list-status-imgs"
                      :src="
                        job.onHold
                          ? require('../../assets/img/newworkbench/internalhiring/card-Onhold.svg')
                          : require('../../assets/img/newworkbench/internalhiring/noti-tick.svg')
                      "
                      alt=""
                    />
                  </span>

                  <span v-if="job.status_display === 'Rejected' && !job.closed"
                    ><img
                      class="IHD-list-status-imgs"
                      src="../../assets/img/newworkbench/internalhiring/noti-rejected.svg"
                      alt=""
                  /></span>
                  <span
                    v-if="
                      (job.status_display === 'Not sent for approval' ||
                        job.status_display === 'Not published') &&
                      !job.closed
                    "
                    ><img
                      class="IHD-list-status-imgs"
                      src="../../assets/img/newworkbench/internalhiring/noti-close.svg"
                      alt=""
                    />
                  </span>
                  <span
                    class="ml-1 IHD-list-status"
                    v-if="!job.closed"
                    :class="{
                      'IHD-inactive-text': !job.active || job.closed,
                    }"
                    >{{
                      (job.status_display === "Accepted" ||
                        job.status_display === "Approved" ||
                        job.status_display === "Published") &&
                      job.onHold
                        ? "On Hold"
                        : job.status_display
                    }}</span
                  >
                </template>
              </div>
            </template>
            <template v-else-if="!job.active">
              <div style="width: 22%">
                <span
                  ><img
                    class="IHD-list-status-imgs"
                    src="../../assets/img/newworkbench/internalhiring/noti-close.svg"
                    alt=""
                  />
                  <span class="ml-1 IHD-list-status IHD-inactive-text"
                    >Inactive</span
                  >
                </span>
              </div>
            </template>
            <template v-else-if="job.closed">
              <div style="width: 22%">
                <span
                  ><img
                    class="IHD-list-status-imgs"
                    src="../../assets/img/newworkbench/internalhiring/noti-close.svg"
                    alt=""
                  />
                  <span class="ml-1 IHD-list-status IHD-inactive-text"
                    >Closed</span
                  >
                </span>
              </div>
            </template>
          </template>
          <div
            :style="roles.includes('PUT_JOB') ? 'width: 13%' : 'width: 15%'"
            class="d-flex align-items-center justify-content-center"
            :class="
              (getCustomerDetail.lead || getCustomerDetail.manager) &&
              (roles.includes('CLONE_JOB') ||
                roles.includes('PUT_JOB') ||
                roles.includes('DELETE_JOB'))
                ? 'gap-10'
                : 'gap-15'
            "
          >
            <img
              v-if="!selectedJD || selectedJD.jobID !== job.jobID"
              @click.stop="selectJD(job), closeViewMore()"
              v-b-tooltip.hover.top="'View'"
              src="../../assets/talentpool/blueEye.svg"
              alt=""
              class="pointer"
            />

            <img
              v-b-tooltip.hover.bottom="'Hide'"
              v-else
              @click.stop="deselectJob(null)"
              src="../../assets/talentpool/notviewicon.svg"
              alt=""
              class="pointer"
            />

            <div class="position-relative">
              <img
                v-if="
                  (getCustomerDetail.lead || getCustomerDetail.manager) &&
                  (roles.includes('CLONE_JOB') ||
                    roles.includes('PUT_JOB') ||
                    roles.includes('DELETE_JOB')) &&
                  viewMoreJDIndex !== index
                "
                @click.stop="openViewMore(index)"
                src="../../assets/New-imgs/switch/threedots.svg"
                alt=""
                class="pointer"
              />
              <img
                ref="dropdown-button"
                @click.stop="closeViewMore()"
                v-if="viewMoreJDIndex === index"
                class="pointer"
                src="../../assets/New-imgs/switch/activethreedots.svg"
                alt=""
                style="
                  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                  border-radius: 50%;
                "
              />
              <div
                class="IHD-list-dropdown position-absolute"
                v-if="viewMoreJDIndex === index"
                ref="dropdown"
              >
                <div
                  class="
                    IHD-list-dropdown-text
                    d-flex
                    align-items-center
                    pointer
                  "
                  v-if="roles.includes('CLONE_JOB')"
                  @click.stop="cloneJD(job)"
                >
                  <img
                    class="mr-2 newIcons-expand"
                    src="../../assets/img/newworkbench/internalhiring/listview-clonejob.svg"
                    alt=""
                  />
                  Clone Job
                </div>
                <div
                  class="
                    IHD-list-dropdown-text
                    d-flex
                    align-items-center
                    pointer
                  "
                  v-if="roles.includes('PUT_JOB') && job.active && !job.closed"
                  @click.stop="goToEditJD(job)"
                >
                  <img
                    class="mr-2 newIcons-expand"
                    src="../../assets/img/newworkbench/internalhiring/listview-editjob.svg"
                    alt=""
                  />
                  Edit Job
                </div>

                <div
                  class="
                    IHD-list-dropdown-text
                    d-flex
                    align-items-center
                    pointer
                  "
                  v-if="
                    roles.includes('DELETE_JOB') && job.active && !job.closed
                  "
                  @click.stop="openModal(job, 'delete')"
                >
                  <img
                    class="mr-2 newIcons-expand"
                    src="../../assets/img/newworkbench/internalhiring/listview-deletejob.svg"
                    alt=""
                  />
                  Delete Job
                </div>

                <div
                  class="
                    IHD-list-dropdown-text
                    d-flex
                    align-items-center
                    pointer
                  "
                  v-if="
                    job.status == '3' &&
                    job.active &&
                    !job.closed &&
                    getCustomerDetail.lead &&
                    !roles.includes('EXTERNAL_ACCESS')
                  "
                  @click.stop="openReassign(job)"
                >
                  <img
                    class="pointer mr-2"
                    src="../../assets/img/newworkbench/internalhiring/listview-reallocatejob.svg"
                    alt=""
                  />
                  Re-Allocate Job
                </div>

                <div
                  class="
                    IHD-list-dropdown-text
                    d-flex
                    align-items-center
                    pointer
                  "
                  v-if="
                    job.active &&
                    !job.closed &&
                    job.status !== '1' &&
                    job.approved &&
                    (getCustomerDetail.lead || getCustomerDetail.manager)
                  "
                  @click.stop="openModal(job, 'close')"
                >
                  <img
                    class="mr-2"
                    src="../../assets/img/newworkbench/internalhiring/listview-closejob.svg"
                    alt=""
                  />
                  Close Job
                </div>

                <div
                  class="
                    IHD-list-dropdown-text
                    d-flex
                    align-items-center
                    pointer
                  "
                  v-if="
                    job.closed &&
                    (getCustomerDetail.lead || getCustomerDetail.manager)
                  "
                  @click.stop="goToEditJD(job)"
                >
                  <img
                    class="mr-2"
                    src="../../assets/img/newworkbench/internalhiring/listview-reopenjob.svg"
                    alt=""
                  />
                  Re-Open Job
                </div>

                <div
                  class="
                    IHD-list-dropdown-text
                    d-flex
                    align-items-center
                    pointer
                  "
                  v-if="!job.active && roles.includes('DELETE_JOB')"
                  @click.stop="goToEditJD(job)"
                >
                  <img
                    class="mr-2"
                    src="../../assets/img/newworkbench/internalhiring/listview-activatejob.svg"
                    alt=""
                  />
                  Activate Job
                </div>
              </div>
            </div>
            <img
              @click.stop="openGraph(job)"
              v-b-toggle="'collapse-' + job.jobID"
              :class="[
                'pointer',
                {
                  'rotate-180 mt-n1': openRows[job.jobID],
                },
              ]"
              src="../../assets/New-imgs/switch/forwardarw.svg"
              alt=""
            />
          </div>
        </div>
        <b-collapse
          :id="'collapse-' + job.jobID"
          v-model="openRows[job.jobID]"
          @show="handleShow(job.jobID)"
        >
          <div
            class="px-3 pb-3"
            v-if="openRows[job.jobID]"
            @click.stop
            style="cursor: default"
          >
            <hr style="border-top: 1px solid #d5d5d5" />
            <div class="d-flex">
              <div style="width: 10%" class="graphdetail-txt">Details:</div>
              <div class="w-75 text-center">
                <b-spinner
                  v-if="loading"
                  style="width: 3rem; height: 3rem"
                  label="Large Spinner"
                  type="grow"
                ></b-spinner>
                <div
                  v-else-if="!hasZeroValue && !loading"
                  id="eachJobGraph"
                  style="width: 100%; height: 100%"
                ></div>
                <img
                  v-else
                  src="../../assets/New-imgs/switch/nodataJobsGraph.svg"
                  alt=""
                />
              </div>
              <div v-if="!hasZeroValue && !loading" style="width: 15%">
                <div class="graph-content-box">
                  <div class="graphdot-txt d-flex align-items-center">
                    <div class="graphdots inprogress-bg mr-2"></div>
                    In-Progress
                  </div>
                  <div class="graphdot-txt d-flex align-items-center">
                    <div class="graphdots selected-bg mr-2"></div>
                    Selected
                  </div>
                  <div class="graphdot-txt d-flex align-items-center">
                    <div class="graphdots onboarded-bg mr-2"></div>
                    On-Boarded
                  </div>
                  <div class="graphdot-txt d-flex align-items-center">
                    <div class="graphdots offer-relsd-bg mr-2"></div>
                    Offer Released
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <FolderModal
      :showModal="showFolderModal"
      @close-modal="closeFolder"
      @save-recruiters="saveRecruiters"
    >
    </FolderModal>
    <CloseJobModal
      v-if="showCloseModal"
      :showCloseModal="showCloseModal"
      :deleteData="fromOnHold ? closejob : delDetails"
      :fromOnHold="fromOnHold"
      :type="actionType"
      :fromCloseModal="showDeleteModal"
      @close-modal="closeMainDeleteModal"
      @show-delete-modal="onCloseJobModal"
      @move-to-on-hold="moveToOnHold"
    />
    <DeleteJobModal
      v-if="showDeleteModal"
      :showDeleteModal="showDeleteModal"
      :deleteData="delDetails"
      :buttonLoader="buttonLoader"
      :fromClose="fromClose"
      :type="actionType"
      @delete-event="
        actionType == 'close' || fromClose ? closejd($event) : deleteJD($event)
      "
      @closeDeleteJd="showDeleteModal = false"
      @go-to-close="showCloseModal = true"
    />
    <CloneModal
      :cloneModal="cloneModal"
      :duplicatecloneName="duplicateCloneName"
      header="Clone Job"
      subHeader="New Job Name"
      placeholder="Enter Job Name"
      errorMessage="Job Name already exists"
      @closeCloneModal="closeCloneModal"
      @handle-clone="cloneJob"
      @change-duplicate-name="duplicateCloneName = false"
      :buttonLoader="buttonLoader"
      buttonName="Clone"
    />
    <ConfirmModal
      v-if="confirmModal"
      @closeModal="confirmModal = false"
      :confirmModal="confirmModal"
      @handle-submit="closejd"
      :button="buttonMsg"
      :header="headerMsg"
      :msg="headerContent"
      :imageSrc="computedImageSrc"
    />
  </div>
</template>

<script>
import jobDashboardMixins from "../../components/mixin/jobDashboardMixin";
import { jobProgessGraph } from "../../components/mixin/jobGraphChart";
import { getCustomerDetails } from "../../utils/apiClient/jobs";

export default {
  mixins: [jobDashboardMixins],
  data() {
    return {
      numbercards: 40,
      opengraph: false,
      selectJobId: null,
      openRows: {},
      hasZeroValue: true,
      loading: true,
    };
  },
  watch: {
    jobList: {
      immediate: true,
      handler(newList) {
        newList.forEach((job) => {
          if (this.openRows[job.jobID] === undefined) {
            this.$set(this.openRows, job.jobID, false);
          }
        });
      },
    },
  },
  methods: {
    async openGraph(job) {
      this.closeViewMore();
      this.loading = true;
      this.selectJobId = this.selectJobId === job.jobID ? null : job.jobID;
      if (this.selectJobId != null) {
        let inProgressCount, offerReleaseCount, onBoardCount, selectedCount;
        try {
          const payload = {
            customerID: this.$route.params.customerID,
            openings: 0,
            selected: 0,
            jobIDs: [job.jobID],
            lead: this.getCustomerDetail.lead || this.getCustomerDetail.manager,
          };
          const response = await getCustomerDetails(payload);
          if (response.status == 200) {
            inProgressCount = response.data.data.inprogress;

            offerReleaseCount = job.stats.offerletterIssued;
            onBoardCount = job.stats.onboarded;
            selectedCount = job.selected;
            console.log(job, "JObs", this.selectJobId);

            const dataGraph = [
              {
                count: inProgressCount,
                name: "In Progress",
              },
              {
                count: selectedCount,
                name: "Selected",
              },
              {
                count: onBoardCount,
                name: "On-Boarded",
              },
              {
                count: offerReleaseCount,
                name: "Offer Released",
              },
            ];
            const width = 1200;
            const height = 110;
            const clrScale = ["#F5D06E", "#0086FF", "#1A4164", "#269C8A"];
            this.hasZeroValue =
              job.approved == false
                ? true
                : dataGraph.every((obj) => obj.count === 0);
            // console.log(this.hasZeroValue, "it hassssssssss zzerrrro "); // Output: true
            if (!this.hasZeroValue) {
              setTimeout(() => {
                this.loading = false;
                if (document.getElementById("eachJobGraph").innerHTML != "") {
                  document.getElementById("eachJobGraph").innerHTML = "";
                }
                let e = new jobProgessGraph();
                e.horizontalBarGraph(
                  "#eachJobGraph",
                  dataGraph,
                  width,
                  height,
                  clrScale
                );
              }, 200);
            }
          } else {
            console.log("error in progress");
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.loading = false;
    },
    handleShow(jobID) {
      // Close all open rows
      Object.keys(this.openRows).forEach((id) => {
        this.$set(this.openRows, id, false);
      });

      // Open the selected one
      this.$set(this.openRows, jobID, true);
    },
  },
};
</script>

<style>
.IHD-table-head {
  min-width: 970px;
  max-width: 100%;
  padding: 10px 0px;
  font-weight: 600;
  font-size: 14px;
  color: var(--bluetheme);
  font-family: var(--lato);
  background: #e9f0f5;
  margin: 0 15px;
}
.IHD-table-minwidth {
  min-width: 970px;
  max-width: 100%;
}
.IHD-table-rows {
  background: #fcfcfc;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  color: var(--bluetheme);
  font-family: var(--lato);
  font-weight: 400;
  font-size: 15px;
  /* margin: 0 10px 0 15px; */
  padding: 15px 0;
}
.IHD-table-blueline {
  position: absolute;
  width: 3px;
  background: #20639b;
  border-radius: 1px;
  top: 3px;
  left: 5px;
  height: 90%;
}
.IHD-table-body {
  height: calc(100vh - 280px);
  min-width: 970px;
  max-width: 100%;
  overflow-y: auto;
  margin: 0 12px 0 17px;
}
.padding10px {
  padding: 10px 10px 0 10px;
}
.margin10px {
  margin: 10px 10px 0 10px;
}
.IHD-list-status {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #7a7a7a;
}
.IHD-inactive-text {
  color: #eb0002 !important;
}
.IHD-inactive-redline {
  background: #eb0002;
}

.IHD-list-status-imgs {
  height: 16px;
  width: 16px;
}
.graph-content-box {
  padding: 10px;
  border: 1px solid #595959;
  border-radius: 12px;
}
.graphdetail-txt {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: #333333;
}

.rotate-180 {
  transform: rotate(180deg);
}
.graphdots {
  width: 6.65px;
  height: 6.65px;
  border-radius: 50%;
}
.graphdot-txt {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 11px;
  color: #333333;
}
.inprogress-bg {
  background: #f5d06e;
}
.selected-bg {
  background: #0086ff;
}
.offer-relsd-bg {
  background: #269c8a;
}
.onboarded-bg {
  background: #1a4164;
}
.h-fitcontent {
  height: fit-content;
}
.r65t7 {
  right: 64px;
  top: 7px;
}
.IHD-list-dropdown {
  width: 150px;
  right: 0;
  height: fit-content;
  padding: 0 10px;
  filter: drop-shadow(0px 8px 15px rgba(0, 0, 0, 0.4));
  background: white;
  z-index: 1;
  border-radius: 5px;
  border: 1px solid #cee3f8;
}
.IHD-list-dropdown-text {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  margin: 10px 0px;
  color: #3a3c40;
}
.accordion-enter-active,
.accordion-leave-active {
  transition: max-height 0.5s ease, opacity 0.5s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}

.accordion-enter-to,
.accordion-leave {
  max-height: 1000px;
  opacity: 1;
}
.IHD-inactive-rows {
  background: #efefef;
  box-shadow: unset;
}
/* .h-50px {
  height: 50px;
} */
</style>
